const words = [
  "Καλώς ήρθατε",
  "Lamb Kleftiko",
  "Family Recipes",
  "Charcoal Grill",
  "Souvlaki",
  "Yamas!",
  "Moussaka",
  "Slow Cooked",
  "Wood Fire",
  "Olive & Lemon",
];

export const Marquee = () => {
  const track = [...words, ...words];
  return (
    <section
      data-testid="marquee"
      className="relative bg-[#2c3528] text-[#f1c98a] py-6 overflow-hidden border-y border-[#f1c98a]/20"
    >
      <div className="marquee-track flex whitespace-nowrap will-change-transform">
        {track.map((w, i) => (
          <div
            key={i}
            className="flex items-center gap-10 px-10 font-serif-display italic text-3xl md:text-4xl"
          >
            <span>{w}</span>
            <span className="text-[#d98a6c] text-2xl leading-none" aria-hidden>
              ✦
            </span>
          </div>
        ))}
      </div>
    </section>
  );
};
